import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';

import { FaPhone } from '@react-icons/all-files/fa/FaPhone';
import { FaGlobe } from '@react-icons/all-files/fa/FaGlobe';
// ------------------------------------------------------------------------------------------

function AboutCompanyCard(props) 
{
  return (
    <>
    { !props?.error && ( 
    <Card>
            <CardContent>
                <Typography variant="h6" component="h2" style={{ marginBottom: '10px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>About { props.company?.name }</Typography>
                <Typography variant="body2" mb={2}>{ props.company?.publicDescription }</Typography>

                { !props?.loading && ( 
                    <>
                    <Stack direction="row" spacing={3} mb={1}>
                        <FaPhone /> 
                        <Typography variant="body2"><Link color="secondary" href={`tel:${props.company?.telephone}`}>{ props.company?.telephone }</Link></Typography>
                    </Stack>
                    <Stack direction="row" spacing={3}>
                        <FaGlobe /> 
                        <Typography variant="body2"><a aria-label={`Website of ${props.company?.name}`} style={{ color: 'rgb(51, 102, 255)' }} href={`${props.company?.website}`} rel="noreferrer" target="_blank">{ props.company?.website }</a></Typography>
                    </Stack>
                    </>
                )}

                { props?.loading && ( 
                    <>
                        <Skeleton width="100%" height={30} />
                        <Skeleton width="100%" height={30} />
                        <Skeleton width="100%" height={30} />
                        <Skeleton width="100%" height={30} />
                    </>
                )}        
            </CardContent>
        </Card>
    )}
    </>
  );
  
}

export default AboutCompanyCard;